export default __webpack_public_path__ + "static/media/loading-dark.12ad24a9.gif";